<template>
  <b-row class="e-lock-tokens">
    <b-col cols="4">
      <div class="d-flex align-items-center justify-content-center mb-3 mt-2 eh-text-small eh-text-gray-dark">
        <span><i class="far fa-credit-card mr-1"></i>Max. 15,000 EMiX</span>
        <span class="ml-auto">Balance: <a href="#" class="font-weight-bold pl-1" @click="onBalanceClick">{{ balance }} EMiX</a></span>
      </div>
      <b-form-input v-model="lockValue"
                    type="number"
                    min="0"
                    :max="balance"
                    :disabled="value.disabled"
      >
      </b-form-input>
      <div class="d-flex align-items-center mt-3 eh-text-small eh-text-gray-dark">
        <span class="text-uppercase font-weight-bold"><i class="fas fa-lock mr-1"></i>Locked for 1 week</span>
      </div>
      <e-hint class="lock-tokens-hint" title="Notice">Please be informed that the tokens you choose to lock will be locked for a 1 Week (AKA 7 Days) After one week you'r token will return to you ewallet and after that you'll be inform if you were rewarded on you moderation or not.</e-hint>
    </b-col>
    <b-col cols="7" offset="1">
      <div class="modal-block-title">Read and Accept the Rules</div>
<div class="rules">
  <div class="rules-wrapper">
    <p>
      By participating in moderation, you agree to review submitted ratings honestly and responsibly. Your role is to help ensure that evaluations follow the defined criteria and represent fair assessments of the asset. Moderators should carefully review each submission before approving or rejecting it.
    </p>

    <p>
      Moderators must avoid conflicts of interest and must not attempt to manipulate ratings for personal benefit. Any suspicious activity, spam submissions, or attempts to influence the rating system unfairly should be rejected or reported through the moderation process.
    </p>

    <p>
      Tokens locked for moderation represent your commitment to the process. They remain locked for the moderation period and are returned after it ends. Depending on the final consensus and quality of moderation, participants may receive rewards for accurate and responsible moderation.
    </p>
  </div>
</div>

      <b-form-checkbox v-model="acceptRules"
                       :value="true"
                       :unchecked-value="false"
                       class="mt-4 legacy-checkbox"
                       :disabled="value.disabled"
      >
        I accept the rules
      </b-form-checkbox>
    </b-col>
  </b-row>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';

  export default {
    name: "e-lock-tokens",
    props: ['value'],
    data() {
      return {
        maxLockTokens: 15000,
      }
    },
    computed: {
      ...mapGetters('auth', {
        balance: 'balance'
      }),
      lockValue: {
        get() {
          return this.value.locked;
        },
        set(v) {
          this.$emit('input', {locked: parseFloat(v), rules: this.value.rules});
        }
      },
      acceptRules: {
        get() {
          return this.value.rules;
        },
        set(v) {
          this.$emit('input', {locked: this.value.locked, rules: v});
        }
      }
    },
    methods: {
      onBalanceClick() {
        if(!this.value.disabled) {
          console.log(this.balance);
          this.lockValue = this.balance > this.maxLockTokens ? this.maxLockTokens : this.balance;
        }
      }
    },
    mounted() {
      console.log(this.value);
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/lockTokens/lockTokens.vue